module.exports = "//cdn.mxpnl.com/static/asset-cache/e00e05a277765593ac077894d24705dd/iron/common/widgets/intro/images/profiles/brad-animated.gif";